import { Component, OnInit, output, signal } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';

@Component({
  selector: 'app-code-input',
  styleUrls: ['./code-input.scss'],
  templateUrl: `./code-input.html`,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],

  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, IconComponent],
})
export class CodeInputComponent implements OnInit {
  childForm = signal<FormGroup | null>(null);
  onenter = output<string>();
  constructor(private parentF: FormGroupDirective) {}
  ngOnInit() {
    this.childForm.set(this.parentF.form);
    this.childForm()?.controls['code'].setValue('');
  }
  onPressEnter() {
    const value = this.childForm().controls['code'].value;
    if (value.length > 0) {
      this.onenter.emit(value);
    }
  }
}
